/**
 * @generated SignedSource<<3319a41bb54e75e83ee50681dbb888c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountSwitch_viewer$data = {
  readonly relatedOwners: ReadonlyArray<{
    readonly name: string;
    readonly platform: string;
  }>;
  readonly " $fragmentType": "AccountSwitch_viewer";
};
export type AccountSwitch_viewer$key = {
  readonly " $data"?: AccountSwitch_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccountSwitch_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountSwitch_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OwnerInfo",
      "kind": "LinkedField",
      "name": "relatedOwners",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "platform",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7072c867a5ff5e21ee88853de910d057";

export default node;
